// assets
/*
import AvatarImg01 from '../assets/images/avatar/avatar-01.png';
import AvatarImg02 from '../assets/images/avatar/avatar-02.png';
import AvatarImg03 from '../assets/images/avatar/avatar-03.png';
import AvatarImg04 from '../assets/images/avatar/avatar-04.png';
import AvatarImg05 from '../assets/images/avatar/avatar-05.png';
*/

import BadgeImg01 from '../assets/images/badge/badge-01-grey.svg';
import BadgeImg02 from '../assets/images/badge/badge-02-grey.svg';
import BadgeImg03 from '../assets/images/badge/badge-03-grey.svg';
import BadgeImg04 from '../assets/images/badge/badge-04-grey.svg';
import BadgeImg05 from '../assets/images/badge/badge-05-grey.svg';
import BadgeImg06 from '../assets/images/badge/badge-06-grey.svg';

import BadgeImg01Color from '../assets/images/badge/badge-01-color.svg';
import BadgeImg02Color from '../assets/images/badge/badge-02-color.svg';
import BadgeImg03Color from '../assets/images/badge/badge-03-color.svg';
import BadgeImg04Color from '../assets/images/badge/badge-04-color.svg';
import BadgeImg05Color from '../assets/images/badge/badge-05-color.svg';
import BadgeImg06Color from '../assets/images/badge/badge-06-color.svg';

// Emoji Assets
import EmojiAsset01 from '../assets/images/icons/emoji_happy.png';
import EmojiAsset02 from '../assets/images/icons/emoji_love.png';
import EmojiAsset03 from '../assets/images/icons/emoji_lol.png';
import EmojiAsset04 from '../assets/images/icons/emoji_sad.png';
import EmojiAsset05 from '../assets/images/icons/emoji_angry.png';

import { config as configInChat } from 'nm-react-chat';

import { firebaseConfig as fbConfig } from './firebase';

// promotion popup config
import PopupImgMobile from '../assets/images/promotions/popup_smart.png';
import PopupImgDesk from '../assets/images/promotions/popup_desk.png'; 

export const promotionPopupConfig = {
  //name of the promotion. will be the name of the cookie
  name: "Kidsmatin sous le sapin", 
  startDate: "05/12/2018",
  endDate: "31/12/2018",
  imgName: PopupImgMobile,
  imgNameDesk: PopupImgDesk,
  //color of the close button use true for a light color background
  closebtnLight: false,
  redirectLink: "https://www.nicematin.com/abonnement/offre/details/201",
  //number of days before the cookie expire
  nbDayBeforeExpire: 100
}

export const firebaseConfig = fbConfig;

export const AuthConfig = {
    // user session expiration time
    expiresIn : 1440, // in minutes => 24h
}

//number of account that we can paired to an address mail
export const nbMaxAccountToPair = 2;

/*export const avatarConfig = [
    AvatarImg01, AvatarImg02, AvatarImg03, AvatarImg04, AvatarImg05, AvatarImg02, AvatarImg01, AvatarImg03, AvatarImg04
];*/

export const avatarConfig = [
    "/assets/images/avatars/avatar-00.png",
    "/assets/images/avatars/avatar-01.png",
    "/assets/images/avatars/avatar-02.png",
    "/assets/images/avatars/avatar-03.png",
    "/assets/images/avatars/avatar-04.png",
    "/assets/images/avatars/avatar-05.png"
];

export const journalistId = "TpwLUIwuNtYbu1QwOSFe7QPhuKY2";
const isPhotoInChatEnabled = false;

configInChat.initConfig(avatarConfig);
configInChat.enabledPhoto(isPhotoInChatEnabled);

export const badgeConfig = [
    {name:"Elève", img:BadgeImg01, imgHover:BadgeImg01Color, pointsRequired:50 },
    {name:"Stagiaire", img:BadgeImg02, imgHover:BadgeImg02Color, pointsRequired:200 },
    {name:"Journaliste", img:BadgeImg03, imgHover:BadgeImg03Color, pointsRequired:500 },
    {name:"Reporter", img:BadgeImg04, imgHover:BadgeImg04Color, pointsRequired:2000 },
    {name:"Rédacteur en chef", img:BadgeImg05,imgHover:BadgeImg05Color, pointsRequired:5000 },
    {name:"Boss suprême", img:BadgeImg06,imgHover:BadgeImg06Color, pointsRequired:10000 },
];

// Config for EmojiWHeel component
export const emojiConfig = [
    {name:"happy", img:EmojiAsset01, value:1 },
    {name:"love", img:EmojiAsset02, value:2 },
    {name:"lol", img:EmojiAsset03, value:3 },
    {name:"sad", img:EmojiAsset04, value:4 },
    {name:"angry", img:EmojiAsset05, value:5 }
];

export const fieldConfig = {
    email: {
        elementType: 'input',
        type:'email',
        defaultValue: '',
        placeholder: 'Email',
        label: 'Adresse Email',
        labelPosition: 1,
        validation: {
            required: [true, 'Ce champs est obligatoire'],
            isEmail: [true, 'Ce champs doit contenir un email valide']
        }
    },
    password: {
        elementType: 'input',
        type:'password',
        defaultValue: '',
        placeholder: 'Mot de passe',
        label: 'Mot de passe',
        labelPosition: 1,
        validation: {
            required: [true, 'Hey ! Tu as oublié d\'écrire ton mot de passe top secret'],
            minLength: [6, 'Un bon mot de passe doit avoir au moins 6 caractères'],
            maxLength: [29, 'Un bon mot de passe doit avoir moins de 30 caractères'],
            isPasswordSecured: [true, 'Ton mot de passe doit avoir au moins une lettre et un chiffre']
        }
    },
    username: {
        elementType: 'input',
        type:'text',
        defaultValue: '',
        placeholder: 'Pseudo',
        label: 'pseudo',
        labelPosition: 1,
        validation: {
            required: [true, 'N\'oublie pas de renseigner ton pseudo pour pouvoir t\'inscrire à Kids Matin'],
            isUsernameValid: [true, 'Ton pseudo ne peut contenir que des lettres sans accents, chiffres, espaces, "." ou "-"'],
            minLength: [3, 'Oups, ton pseudo est trop court, il doit comporter au minimum 3 caractères :/'],
            maxLength: [19, 'Oups, ton pseudo est trop long, il doit comporter au maximum 20 caractères :/'],
        }
    },
    firstname: {
        elementType: 'input',
        type:'text',
        defaultValue: '',
        placeholder: 'Prénom',
        label: 'Prénom',
        labelPosition: 1,
        validation: {
            required: [true, 'Ce champs est obligatoire'], 
            minLength: [2, 'Ce champs doit contenir au minimum 2 caractères']
        }
    },
    lastname: {
        elementType: 'input',
        type:'text',
        defaultValue: '',
        placeholder: 'Nom',
        label: 'Nom',
        labelPosition: 1,
        validation: {
            required: [true, 'Ce champs est obligatoire'],
            minLength: [2, 'Ce champs doit contenir au minimum 2 caractères']
        }
    },
    birthday: {
        elementType: 'input',
        type:'date',
        defaultValue: '',
        placeholder: 'Date de naissance',
        label: 'Date de naissance',
        labelPosition: 1,
        validation: {
            required: [true, 'N\'oublie pas de renseigner ta date de naissance'],
            isBirthdayDateValid: [true, 'ta date d\'anniversaire doit être au format jj/mm/aaaa']
        }
    },
    city: {
        elementType: 'PlaceAutocomplete',
        type: 'text',
        defaultValue: '',
        placeholder: 'Ma Ville',
        label: 'ville',
        labelPosition: 1,
        validation: {
            required: [false, ''],
            minLength: [2, 'Ce champs doit contenir au minimum 2 caractères']
        },
        options: {
            types: ['(cities)'],
            componentRestrictions: {
                country: ['FR','MC']
              }
        }
    },
    avatar: {
        elementType: 'avatar',
        type:'radio',
        defaultValue: 0, // by default, no avatar is selected and the Carousel Component will display the one from the middle
        options: {
            images: avatarConfig,
        },
        placeholder: 'Avatar',
        label: 'Avatar',
        labelPosition: 0,
        validation: {
        }
    },
    label: {
        elementType:'label',
        title:'',
    },
    checkbox:{
        elementType: 'input',
        type:'checkbox',
        defaultValue: '',
        placeholder: '',
        labelPosition: 1,
        validation: {
        } 
    },
    link: {
      elementType:'link',
      text: '',
      destination: ''
    },
    submit: {
        elementType: 'input',
        type:'submit',
        label: 'Se connecter',
        labelPosition: 0,
        defaultValue: 'Se connecter'
    }
}

export const pointsConfig = {
    'read': 1,
    'react': 5,
    'comment': 10,
    'answer': 20,
    'ask': 50
}
export const blocBouchonConfig = {
    howToEarnPoints :{
        title : "On t'explique comment gagner des points et recevoir des cadeaux",
        titleColor:'#ffde39',
        background:'#fc8497',
        link: ''
    },
    lastEdition : {
        title : "Il s'est passé quoi la semaine dernière ? ",
        titleColor:'#000',
        background: '#ffde39',
        link: ''
    }
}

export const responsiveBreakpointConfig = [
    {profile : 'mobile', minWidth:0, maxWidth:767 },
    {profile : 'desktop', minWidth:768, maxWidth:3000 },  
]

//export const linkSubscribe = "https://www.nicematin.com/abonnement/offre/details/161"
//export const linkSubscribe = "https://www.nicematin.com/abonnement/offre/161?utm_source=Site_KM&utm_campaign=KM_Bouton_Jemabonne"
//export const linkSubscribe = "https://abo.nicematin.com/cart/products/add?product_id=651"
export const linkSubscribe = "https://abo.nicematin.com/abonnement/formule/kids-matin/828"
export const linkEarnPoints = "https://lp.nicematin.com/comment-gagner-des-points/";


// WEBPACK FOOTER //
// ./src/conf/config.js